import useFetch from 'use-http'
import { Navigate } from "react-router-dom";

export const GoogleCallback = ({ code }) => {
    const options = { credentials: 'include' }
    const { loading } = useFetch(`${process.env.REACT_APP_PEER_REVIEW_API_URL}/googleCallback${window.location.search}`, options, [])

    return loading ? "loading" : <Navigate to='/'></Navigate>
}